/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivateCollectorLicenseRequest
 */
export interface ActivateCollectorLicenseRequest {
    /**
     * 
     */
    machineCode?: string;
}

/**
 * Check if a given object implements the ActivateCollectorLicenseRequest interface.
 */
export function instanceOfActivateCollectorLicenseRequest(value: object): value is ActivateCollectorLicenseRequest {
    return true;
}

export function ActivateCollectorLicenseRequestFromJSON(json: any): ActivateCollectorLicenseRequest {
    return ActivateCollectorLicenseRequestFromJSONTyped(json, false);
}

export function ActivateCollectorLicenseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateCollectorLicenseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'machineCode': json['machineCode'] == null ? undefined : json['machineCode'],
    };
}

export function ActivateCollectorLicenseRequestToJSON(json: any): ActivateCollectorLicenseRequest {
    return ActivateCollectorLicenseRequestToJSONTyped(json, false);
}

export function ActivateCollectorLicenseRequestToJSONTyped(value?: ActivateCollectorLicenseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'machineCode': value['machineCode'],
    };
}

